import React from "react";
import { Tile } from "./primitives";

export default function MilestonesPanel({ milestones, onResend }) {
  const c60 = milestones?.counts?.["60"] ?? 0;
  const c80 = milestones?.counts?.["80"] ?? 0;
  const items = milestones?.items || [];
  const mailerOff = milestones && milestones.mailer_configured === false;

  return (
    <Tile
      title={`Readiness milestones · 60=${c60} · 80=${c80}`}
      testid="tile-milestones"
    >
      {items.length === 0 ? (
        <div className="text-xs text-[#5C6B62]">
          No milestone emails captured yet. Users cross 60 or 80 on the workbook to enter this list.
          {mailerOff && (
            <div className="mt-2 text-[10px] text-[#C26747]">
              Note: RESEND_API_KEY is not set — captures are stored but no emails will send.
            </div>
          )}
        </div>
      ) : (
        <div className="space-y-1 max-h-64 overflow-y-auto">
          {items.map((m) => (
            <div
              key={`${m.email}-${m.milestone}`}
              className="text-[11px] flex items-center justify-between gap-2 border-b border-[#F0EFEA] pb-1 last:border-0"
            >
              <span className="text-[#1C2B23] truncate">{m.email}</span>
              <span className="font-mono-num text-[#2B5339]">{m.score}/100</span>
              <span className="text-[10px] uppercase tracking-wider text-[#5C6B62]">@{m.milestone}</span>
              <span
                className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                  m.email_status === "sent"
                    ? "bg-[#E8F0EB] text-[#2B5339]"
                    : m.email_status === "failed"
                      ? "bg-[#FDF2ED] text-[#C26747]"
                      : "bg-[#F0EFEA] text-[#5C6B62]"
                }`}
                title={m.email_error || ""}
              >
                {m.email_status || "queued"}
              </span>
              <button
                data-testid={`resend-${m.email}-${m.milestone}`}
                onClick={() => onResend(m.email, m.milestone)}
                className="text-[10px] text-[#2B5339] hover:underline"
              >
                Resend
              </button>
            </div>
          ))}
        </div>
      )}
    </Tile>
  );
}
